import { useState, useCallback } from 'react'
import { EditHistory } from '../types/database'

export const useEditHistory = () => {
  const [history, setHistory] = useState<EditHistory[]>([])
  const [currentIndex, setCurrentIndex] = useState(-1)

  const addEdit = useCallback((edit: Omit<EditHistory, 'id' | 'timestamp'>) => {
    const newEdit: EditHistory = {
      ...edit,
      id: Date.now().toString(),
      timestamp: new Date()
    }

    // 現在位置より後の履歴を削除
    const newHistory = history.slice(0, currentIndex + 1)
    newHistory.push(newEdit)
    
    setHistory(newHistory)
    setCurrentIndex(newHistory.length - 1)
  }, [history, currentIndex])

  const undo = useCallback(() => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
    }
  }, [currentIndex])

  const redo = useCallback(() => {
    if (currentIndex < history.length - 1) {
      setCurrentIndex(currentIndex + 1)
    }
  }, [currentIndex, history.length])

  const canUndo = currentIndex > 0
  const canRedo = currentIndex < history.length - 1
  const editCount = history.length

  const clearHistory = useCallback(() => {
    setHistory([])
    setCurrentIndex(-1)
  }, [])

  const getCurrentEdit = useCallback(() => {
    return currentIndex >= 0 ? history[currentIndex] : null
  }, [history, currentIndex])

  const getEditAt = useCallback((index: number) => {
    return index >= 0 && index < history.length ? history[index] : null
  }, [history])

  return {
    history,
    currentIndex,
    editCount,
    canUndo,
    canRedo,
    addEdit,
    undo,
    redo,
    clearHistory,
    getCurrentEdit,
    getEditAt
  }
} 